import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import HCLAppscanCredentialsForm from "./HCLAppscanCredentialsForm";
import HCLAppscanMappingForm from "./HCLAppscanMappingForm";

const HCLAppscanConfigListing = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Applications",
        dataIndex: "applicationName",
        width: 130,
        render: columnRenderArrayData,
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={HCLAppscanMappingForm}
      CredentialsForm={HCLAppscanCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default HCLAppscanConfigListing;
